


export const SetpointStateTypes = [
    { name: "Active", value: "active" },
    { name: "Send", value: "send" },
    { name: "Deprecated", value: "deprecated" },
];